import React, { useState } from 'react';
import './StyleRemix.css';

const STYLE_CHIPS = [
  { label: '🖌️ Watercolor', modifier: 'watercolor painting style, soft washes of color, delicate brushstrokes' },
  { label: '⚡ Cyberpunk',  modifier: 'cyberpunk neon style, dark dystopian, glowing neon lights, high-tech futuristic' },
  { label: '🌿 Nature',     modifier: 'organic nature style, botanical illustration, earthy tones, hand-drawn flora' },
  { label: '✍️ Sketch',     modifier: 'pencil sketch style, black and white line drawing, detailed crosshatching, hand-drawn' },
];

export default function StyleRemix({ prompt, onRemix, isLoading }) {
  const [active, setActive] = useState(null);

  if (!prompt) return null;

  const handleClick = (chip) => {
    if (isLoading) return;
    setActive(chip.label);
    const remixPrompt = `${prompt}, ${chip.modifier}`;
    // Pass both the remix prompt and the style label so the chain can display it
    onRemix(remixPrompt, chip.label);
    // Clear active state after a moment
    setTimeout(() => setActive(null), 2000);
  };

  return (
    <div className="style-remix">
      <span className="style-remix-label">Remix style:</span>
      <div className="style-remix-chips">
        {STYLE_CHIPS.map((chip) => (
          <button
            key={chip.label}
            className={`style-remix-chip ${active === chip.label ? 'active' : ''} ${isLoading ? 'disabled' : ''}`}
            onClick={() => handleClick(chip)}
            disabled={isLoading}
            title={`Re-generate as: ${chip.modifier}`}
          >
            {chip.label}
          </button>
        ))}
      </div>
    </div>
  );
}
